global.$ = global.jQuery = require('jquery');
import CountDown from "./classes/CountDown";
import Swiper from './vendor/swiper-bundle.min';

require('bootstrap/js/src/modal')

// Countdown
function newCountDown() {
    const now = new Date()
    const seconds = now.getSeconds()
    const minutes = now.getMinutes() % 30
    const hours = now.getHours() % 2
    const secondsToAdd = ((minutes * 60) + (hours * 60 * 60) + seconds);
    new CountDown('js-countdown-el', new Date(now.getTime() + ((9000 - secondsToAdd) * 1000)), () => {
        newCountDown()
    })
}
newCountDown()

$(document).ready(() => {
    // Logos slider
    const logoSlider = new Swiper('.js-logo-slider', {
        slidesPerView: 'auto',
        speed: 5000,
        loop: true,
        autoplay: {
            delay: 0
        }
    });
})
